import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  error: {
    id: 'studio.jqm8s7',
    defaultMessage: 'Something went wrong when trying to load the apps.',
  },
  loading: {
    id: 'studio.mLmrec',
    defaultMessage: 'Loading apps…',
  },
  emptyApps: {
    id: 'studio.dkCG8O',
    defaultMessage: 'There are currently no apps available.',
  },
  noApps: {
    id: 'studio.DCjIUV',
    defaultMessage: 'There are no apps that match your search parameters.',
  },
});
